import { render, staticRenderFns } from "./migrateData.vue?vue&type=template&id=31ee3ca8"
import script from "./migrateData.vue?vue&type=script&lang=js"
export * from "./migrateData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports